import { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

export type ScrollToTopProps = RouteComponentProps<any> & {
}

class ScrollToTop extends Component<ScrollToTopProps> {
    componentDidUpdate(prevProps: ScrollToTopProps) {
      const { location } = this.props;
      if (location.pathname !== prevProps.location.pathname) {
        window.scrollTo(0, 0);
      }
    }
  
    render() {
      const { children } = this.props;
      return children;
    }
  }
  
  export default withRouter(ScrollToTop);